import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE} from '@app/constants/Common';
import {ConnectCddEmpTabs} from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";

const MailTemplateListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(1);
    const [emailList, setEmailList] = useState([]);
    const [searchCondition, setSearchCondition] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [currentTabId, setCurrentTabId] = useState({});

    const {onEditItem, onDuplicateItem, sortColumn, tabId} = props
    const {templates, totalCount, onSort, onSearch} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setCurrentTabId(tabId)
    }, [tabId])

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const onSearchClick = (condition) => {
        if (!condition.page) {
            condition.page = currentPage
        }

        condition.size = DEFAULT_PAGE_SIZE
        setSearchCondition(condition)
        return onSearch(condition)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    useEffect(() => {
        setEmailList([...templates])
    }, [templates])

    useEffect(() => {
        setNumberPages(Math.ceil(totalCount/DEFAULT_PAGE_SIZE))
    }, [totalCount])

    const onClickSortColumn = (column) => {
        if (onSort) {
            onSort(column.key)
        }
    }

    const classSortingType = (column) => {
        const sortType = sortColumn[column]
        if (sortType) {
            return sortType === ODER_BY_TYPE.DESC ? 'sorting_desc' : 'sorting_asc'
        }

        return ""
    }

    return (
        <>
            <table
                className='table table-bordered table-hover dataTable dtr-inline text-nowrap text-center'
            >
                <thead>
                <tr>
                    <th>No.</th>
                    <th className={`sorting ${classSortingType('id')}`} onClick={() => onClickSortColumn('id')}>ID</th>
                    {tabId === ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id && (
                        <>
                            <th className={`sorting ${classSortingType('cdd_id')}`}
                                onClick={() => onClickSortColumn('cdd_id')}>Cdd ID
                            </th>
                            <th className={`sorting ${classSortingType('cdd_full_name')}`}
                                onClick={() => onClickSortColumn('cdd_full_name')}>Họ và tên Cdd
                            </th>
                            <th className={`sorting ${classSortingType('cdd_displayed_company')}`}
                                onClick={() => onClickSortColumn('cdd_displayed_company')}>Displayed Company
                            </th>
                            <th className={`sorting ${classSortingType('cdd_displayed_title')}`}
                                onClick={() => onClickSortColumn('cdd_displayed_title')}>Displayed Title
                            </th>
                            <th className={`sorting ${classSortingType('cdd_local_province')}`}
                                onClick={() => onClickSortColumn('cdd_local_province')}>Location
                            </th>
                        </>
                    )}
                    <th className={`sorting ${classSortingType('name')}`} onClick={() => onClickSortColumn('name')}>Tên template</th>
                    <th className={`sorting ${classSortingType('note')}`} onClick={() => onClickSortColumn('note')}>Note</th>
                    <th className={`sorting ${classSortingType('updated_date_time')}`} onClick={() => onClickSortColumn('updated_date_time')}>Ngày update</th>
                    <th>Hành động</th>
                </tr>
                </thead>
                <tbody>
                {emailList && emailList.length > 0 && emailList.map((template, index) => (
                    <tr key={`template_${index}`}>
                        <td>{template.no ? template.no : index + 1}</td>
                        <td className={"text-truncate"}>
                            <a href="javascript:void(0)" onClick={() => onEditItem(template)}>
                                {template.id}
                            </a>
                        </td>
                        {tabId === ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id && (
                            <>
                                <td className={"text-truncate"}>
                                    <a href={`/candidate/detail/${template.cdd_id}`} target="_blank" rel="noreferrer">{template.cdd_id}</a>
                                </td>
                                <td className={"text-truncate"}>{template.cdd_full_name}</td>
                                <td className={"text-truncate"}>{template.cdd_displayed_company}</td>
                                <td className={"text-truncate"}>{template.cdd_displayed_title}</td>
                                <td className={"text-truncate"}>{template.cdd_local_province}</td>
                            </>
                        )}
                        <td className={"text-truncate"}>{template.name}</td>
                        <td className={"text-truncate"}>{template.note}</td>
                        <td className={"text-truncate"}>{template.updated_date_time}</td>
                        <td className={"text-truncate"}>
                            <button type="button" className="btn btn-info"
                                    onClick={() => onDuplicateItem(template)}>
                                Duplicate
                            </button>
                            <button type="button" className="btn btn-default ml-2"
                                    onClick={() => onEditItem(template)}>
                                Edit
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </>
    );
};

export default MailTemplateListTable;
